<template>
  <div class="block_wrap">
    <div class="response_table">
      <div class="title">
        <h4>
          {{ translate('client.groups.device_groups.title') }}
          ({{ device_groups.length }})
        </h4>
        <router-link :to="'/device_list?client_id=' + $route.params.client_id">
          {{ translate('client.groups.device_groups.all_devices') }}
        </router-link>
      </div>
      <table>
        <thead>
          <tr>
            <th scope="col">
              {{ translate('client.groups.device_groups.name') }}
            </th>
            <th scope="col">
              {{ translate('client.groups.device_groups.total') }}
            </th>
            <th scope="col">
              {{ translate('client.groups.device_groups.config_default') }}
            </th>
            <th scope="col">
              {{ translate('client.groups.device_groups.ts') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <router-link
            v-for="(device_group,key) in device_groups"
            :key="key"
            :to="'/device_list?group=' + device_group.id"
            class="group"
          >
            <tr
              class="pointer"
            >
              <td :data-label="translate('client.groups.device_groups.name')">
                <router-link :to="{ path: '/device_list?group=' + device_group.id }">
                  {{ device_group.name }}
                </router-link>
                <router-link
                    v-if="$store.getters.getPermissions.permissionGod === true"
                    :to="{ path: '/device_groups?group_id=' + device_group.id }"
                >
                  <span class="mdi mdi-pen"></span>
                </router-link>
              </td>
              <td :data-label="translate('client.groups.device_groups.total')">
                {{ device_group.total }}
              </td>
              <td :data-label="translate('client.groups.device_groups.config_default')">
                {{ device_group.config_default }}
              </td>
              <td :data-label="translate('client.groups.device_groups.ts')">
                {{ get_date(device_group.ts_create) }}
              </td>
            </tr>
          </router-link>
        </tbody>
      </table>
    </div>


    <div class="response_table">
      <div class="title">
        <h4>
          {{ translate('client.groups.device_simcard_groups.title') }}
          ({{ device_simcard_groups.length }})
        </h4>
        <router-link :to="'/simcard_devices_list?client_id=' + $route.params.client_id">
          {{ translate('client.groups.device_simcard_groups.all_simcards') }}
        </router-link>
      </div>
      <table>
        <thead>
          <tr>
            <th scope="col">
              {{ translate('client.groups.device_simcard_groups.name') }}
            </th>
            <th scope="col">
              {{ translate('client.groups.device_simcard_groups.total') }}
            </th>
            <th scope="col">
              {{ translate('client.groups.device_simcard_groups.ts') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <router-link
              v-for="(device_simcard_group,key) in device_simcard_groups"
              :key="key"
              :to="'/simcard_devices_list?group=' + device_simcard_group.id"
              class="group"
           >
            <tr class="pointer" >
              <td :data-label="translate('client.groups.device_simcard_groups.name')">
                {{ device_simcard_group.name }}
              </td>
              <td :data-label="translate('client.groups.device_simcard_groups.total')">
                {{ device_simcard_group.total }}
              </td>
              <td :data-label="translate('client.groups.device_simcard_groups.ts')">
                {{ get_date(device_simcard_group.ts_create) }}
              </td>
            </tr>
          </router-link>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

export default {
  name: 'ClientGroups',
  data () {
    return {
      device_groups: [],
      device_simcard_groups: []
    }
  },

  mounted() {
    this.get_client_groups()
  },

  methods: {
    get_client_groups () {
      this.$http.v1.getClientGroups(this.$route.params.client_id, (response) => {
        this.device_groups = response.data.device_groups
        this.device_simcard_groups = response.data.device_simcard_groups
      })
    },
  }
}

</script>

<style lang='scss' scoped>
.block_wrap{
  height: 100%;
  .response_table{
    height: 50%;
    padding: 0;
    margin-bottom: 10px;
    &:last-child{
      margin-bottom: 0;
    }
    .title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      a{
        cursor: pointer;
      }
      h4{
        font-size: 16px;
        height: 20px;
        margin: 10px 0;
        text-align: left;
      }
    }

    table{
      height: calc(100% - 40px);
      tbody{
        .group{
          color: #333333;
          &:hover{
            tr{
              background-color: #eee;
            }
          }
        }
      }
    }

    &:last-child{
      margin-bottom: 0;
    }
  }
}

</style>
